import { Avatar, Grid, Tab, Tabs } from "@mui/material";
import { EmployeeModel } from "domains/models/EmployeeModel";
import { observer } from "mobx-react";
import React from "react";
import { useRootStore } from "store/StoreContextProvider";
import EmployeeDetailPageStore from "../store/EmployeeDetailPageStore";
import { styled } from "@mui/material/styles";

const CustomTabs = styled(Tabs)`
  color: #ababab;

  .css-1a4240h-MuiButtonBase-root-MuiTab-root.Mui-selected {
    color: #000000;
  }
`;

const CustomTab = styled(Tab)`
  color: #ababab;

  & .Mui-selected {
    color: #000000;
  }
`;

interface Props {
  pageStore: EmployeeDetailPageStore;
}
function TaskListTabs(props: Props) {
  const { loginStore } = useRootStore();

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    props.pageStore.setTabsValue(newValue);
    props.pageStore.fetchTaskList(loginStore.currentUser);
    props.pageStore.setOpenPopper(false);
  };
  return (
    <CustomTabs
      TabIndicatorProps={{
        sx: {
          background: "black",
        },
      }}
      value={props.pageStore.tabsValue}
      onChange={handleChange}
      variant="fullWidth"
      aria-label="topTabs_Employee"
      centered
    >
      <CustomTab
        style={{
          textTransform: "none",
          fontFamily: "Pretendard",
          fontStyle: "normal",
          fontWeight: 500,
          fontSize: "15px",
          lineHeight: "15px",
        }}
        value="TODO"
        label="Todo"
        disabled={props.pageStore.isLoading}
      />
      <CustomTab
        style={{
          textTransform: "none",
          fontFamily: "Pretendard",
          fontStyle: "normal",
          fontWeight: 500,
          fontSize: "15px",
          lineHeight: "15px",
        }}
        value="DONE"
        label="Done"
        disabled={props.pageStore.isLoading}
      />
    </CustomTabs>
  );
}

export default observer(TaskListTabs);
